import React from "react";

function Thankyou_receipt() {

    return (
        <div className="container">
            <div className="row">
                <div className="col-lg-4 col-12 m-auto">
                    <div className="receipt">
                        <div className="receipt__logo">
                            <img src={process.env.PUBLIC_URL + '/images/tankyou-logo.png'} alt="" title="" className="receipt__logo__img img-fluid" />
                            <h2 className="receipt__logo__text">پرداخت با موفقیت انجام شد</h2>
                        </div>
                        <div className="receipt__details">
                            <p className="receipt__details__item">
                                <span className="receipt__details__item--name">تاریخ</span>
                                <span className="receipt__details__item--value">۱۴۰۱/۱۲/۲۵</span>
                            </p>
                            <p className="receipt__details__item">
                                <span className="receipt__details__item--name">ساعت</span>
                                <span className="receipt__details__item--value">۱۷:۴۴:۲۲</span>
                            </p>
                            <p className="receipt__details__item">
                                <span className="receipt__details__item--name">کارت مبدا</span>
                                <span className="receipt__details__item--value">۶۱۰۴********۲۰۲۲</span>
                            </p>
                            <p className="receipt__details__item">
                                <span className="receipt__details__item--name">کارت مقصد</span>
                                <span className="receipt__details__item--value">۶۰۳۷********۴۰۴۱</span>
                            </p>
                            <p className="receipt__details__item">
                                <span className="receipt__details__item--name">مبلغ</span>
                                <span className="receipt__details__item--value">283,000 تومان</span>
                            </p>
                        </div>
                        <div className="receipt__code">
                            <span className="receipt__code--name">کد پیگیری</span>
                            <span className="receipt__code--value">22369578642</span>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );

}

export default Thankyou_receipt;